<template>
  <div v-if="isInterTheme" class="rodape-sobre-acerto">
    <div class="rodape-sobre-acerto__conteudo">
      <h4 class="rodape-sobre-acerto__titulo">Portal de Renegociação - Inter</h4>
      <p class="rodape-sobre-acerto__texto">
        Somos um banco digital que te dá autonomia para colocar a sua vida financeira em dia sem comprometer o
        orçamento. Pelo computador ou pelo Super App, é possível renegociar dívidas do cartão de crédito Inter 100%
        online, com opções de parcelamento que cabem no bolso, de forma simples, rápida e segura. Nosso objetivo é
        ajudar você a desenrolar suas finanças e voltar a ficar em dia.
      </p>
    </div>
  </div>
  <div v-else class="rodape-sobre-acerto">
    <img :src="logoAcerto" class="rodape-sobre-acerto__logo" alt="acerto.">
    <div class="rodape-sobre-acerto__conteudo">
      <h4 class="rodape-sobre-acerto__titulo">Sobre a Acerto</h4>
      <p class="rodape-sobre-acerto__texto">
        A Acerto é uma plataforma digital de negociação de dívidas que dá ao consumidor o protagonismo para organizar
        sua vida financeira. Pelo computador ou celular, é possível negociar débitos com instituições financeiras,
        varejistas e de telecomunicações de forma fácil, rápida e automatizada. Nossa missão é facilitar o caminho
        até o seu bem-estar financeiro.
      </p>
      <a
        class="rodape-sobre-acerto__link"
        :href="urlSobre"
        target="_blank"
        rel="noreferrer"
        data-ua="click-nav-rodape-sobre"
      >
        Conheça mais →
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import logoAcerto from '@/assets/images/logo-meu-acerto-short.svg';
import theme from '@/services/ThemeService';

const urlSobre = appSettings.VUE_APP_URL_SITE_INSTITUCIONAL;
const isInterTheme = theme.isInterTheme();
</script>

<style scoped lang="scss">
@use "@/assets/styles/functions.scss" as *;
@use "@/assets/styles/vars" as *;

.rodape-sobre-acerto {
  display: flex;
  align-items: flex-start;
  gap: $space-xs;
}

.rodape-sobre-acerto__logo {
  flex-shrink: 0;
  width: 38px;
  height: auto;
  margin-top: 2px;
}

.rodape-sobre-acerto__conteudo {
  display: flex;
  flex-direction: column;
  gap: px2rem(10px);
}

.rodape-sobre-acerto__titulo {
  margin: 0;
  font-size: px2rem(15px);
  font-weight: 800;
  color: var(--neutral-00, #131416);
}

.rodape-sobre-acerto__texto {
  margin: 0;
  font-size: px2rem(13.5px);
  line-height: 1.6;
  color: var(--neutral-77, #777);
}

.rodape-sobre-acerto__link {
  font-size: px2rem(13.5px);
  font-weight: 700;
  text-decoration: none;
  color: var(--acerto-colors-green-700, #1f7a40);

  &:hover,
  &:focus-visible {
    color: var(--acerto-colors-green-800, #197a38);
  }
}
</style>
